import React from "react";
import { withApollo } from "react-apollo";

import Subcategory from "./Subcategory/Subcategory"

import { getListOfSubcategoriesforFolderUploadQuery, getSubcategoryListQuery } from "../../services/graphql/queries/category-management";

import { errorMessage } from "../../miscellaneous/error-messages";
import { errorMsg } from "../../miscellaneous/react-toastify";

class CategoryDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      category: props.category,
      activeMenu: "Subcategory",
      subcategory:[],
    };
    this.changeMenu = this.changeMenu.bind(this);
  }

  changeMenu(e, menu) {
    e.preventDefault();
    this.setState({ activeMenu: menu });
  }

  getListofSubcategory() {
    this.props.client
      .query({
        query: getListOfSubcategoriesforFolderUploadQuery,
        variables: {
          categoryId: parseInt(this.props.category.id),
          subcategoryLevel: 1
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        const subcategory = result.data.getListOfSubcategoriesforFolderUpload;

        this.initialState = {
          subcategory: subcategory
        };
        this.setState({
          ...this.initialState,
          activeMenu: subcategory.length > 0 ? subcategory[0].name : "",
          loading: false,
          error: ""
        });
      })
      .catch(error => {
        console.log("~~~error: ", error);
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, error: error.message });
      });
  }

  componentDidMount(){
    this.getListofSubcategory();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.category !== this.props.category) {
      this.setState({ category: this.props.category });
    }
  }

  render() {
    const {
      category,
      activeMenu,
      subcategory,
    } = this.state;    
    return (
      <div className="tab-style-1">
        {subcategory.length?(
          <div
            className="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            {/* <a 
                className={activeMenu === "Subcategory"? "nav-link active": "nav-link"} 
                id="doc-tab" data-toggle="pill" href="#doc" role="tab" aria-controls="doc" aria-selected="false" 
                onClick={e => {
                    this.changeMenu(e, "Subcategory");
                }}>
                <span>Subcategory</span>
            </a> */}
            {subcategory.map((data, index) => (
              <a
                key={index}
                className={
                  activeMenu === data.name 
                  ? "nav-link active" 
                  : "nav-link"
                }
                id={"doc-tab" + index}
                data-toggle="pill"
                href="#doc"
                role="tab"
                aria-controls="doc"
                aria-selected="false"
                onClick={e => {
                  this.changeMenu(
                    e,
                    data.name,
                    index + 1
                  );
                }}
              >
                <span>{data.name}</span>
              </a>
            ))}
          </div>
        ) : (
          null
        )}
        <div className="tab-content" id="v-pills-tabContent">
          {/* {activeMenu === "Subcategory"  ? (
            <Subcategory
            category={category}
            />
          ) : null} */}
          {subcategory.length > 0 ? (
            subcategory.map((category, index) => (
              <div key={index}>
                {activeMenu === category.name && (
                  <Subcategory category={category} />
                )}
              </div>
            ))
          ) : (
            null
          )}
        </div>
      </div>
    );
  }
}

export default withApollo(CategoryDetails);
